module.exports = __webpack_public_path__ + "static/media/like.4ec015b8.svg";